"use strict";

require("core-js/modules/es6.array.map");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _tag = _interopRequireDefault(require("@alifd/next/lib/tag"));

var _Colored = _interopRequireDefault(require("./Colored"));

var _constants = require("./constants");

var TagGroup = _tag["default"].Group;
var defaultAvaliableColors = [_constants.Color.LIGHT_STEEL_BLUE, _constants.Color.PLUM, _constants.Color.MISTY_ROSE, _constants.Color.LIGHT_GOLDENROD_YELLOW, _constants.Color.PALE_GREEN];

var ColoredGroup = function ColoredGroup(_ref) {
  var className = _ref.className,
      style = _ref.style,
      _ref$avaliableColors = _ref.avaliableColors,
      avaliableColors = _ref$avaliableColors === void 0 ? defaultAvaliableColors : _ref$avaliableColors,
      children = _ref.children;
  return _react["default"].createElement(TagGroup, {
    className: (0, _classnames["default"])(_constants.COLORED_GROUP_CLASS_NAME, className),
    style: style
  }, _react.Children.map(children, function (elem, i) {
    var hijackedElem = elem;

    try {
      var protectedElemType = elem.type[_constants.PROTECTED_TYPE];

      if (protectedElemType === 'Tag') {
        hijackedElem = _react["default"].createElement(_Colored["default"], (0, _extends2["default"])({}, elem.props, {
          type: avaliableColors[i % 5]
        }));
      }
    } catch (err) {
      /** DO NOT thrown unexpected error but swallow it */
    }

    return hijackedElem;
  }));
};

ColoredGroup.propTypes = {
  className: _propTypes["default"].string,
  style: _propTypes["default"].objectOf(_propTypes["default"].any),
  avaliableColors: _propTypes["default"].arrayOf(_propTypes["default"].string),
  children: _propTypes["default"].node
};
var _default = ColoredGroup;
exports["default"] = _default;